/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_List_FailedInputs */

const en_us2_exercise_list_failed = /** @type {(inputs: Exercise_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the exercises.`)
};

const pt_br2_exercise_list_failed = /** @type {(inputs: Exercise_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os exercícios.`)
};

const es_419_exercise_list_failed = /** @type {(inputs: Exercise_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar los ejercicios.`)
};

const pt_pt2_exercise_list_failed = /** @type {(inputs: Exercise_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os exercícios.`)
};

const fr_fr2_exercise_list_failed = /** @type {(inputs: Exercise_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les exercices.`)
};

const de_de2_exercise_list_failed = /** @type {(inputs: Exercise_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Übungen konnten nicht geladen werden.`)
};

const it_it2_exercise_list_failed = /** @type {(inputs: Exercise_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare gli esercizi.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the exercises." |
*
* @param {Exercise_List_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_list_failed = /** @type {((inputs?: Exercise_List_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_List_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_list_failed(inputs)
	if (locale === "es-419") return es_419_exercise_list_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_list_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_list_failed(inputs)
	if (locale === "de-DE") return de_de2_exercise_list_failed(inputs)
	if (locale === "it-IT") return it_it2_exercise_list_failed(inputs)
	return en_us2_exercise_list_failed(inputs)
});
export { exercise_list_failed as "exercise.list_failed" }